import ButtonRow from 'lib/src/components/button/ButtonRow';
import LinkButton from '@components/button/LinkButton';
import DataCheck from 'lib/src/components/common/DataCheck';
import Table from 'lib/src/components/table/Table';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';
import { ChallengeTag } from 'lib/src/types/shared/ChallengeTag';
import { Column } from 'lib/src/types/table';
import { isEmpty } from 'lib/src/utils/generic';
import useFetchChallengeTags from './challengeIXProgramme/hooks/useChallengeTags';
import { getTagRouteEndpoint } from './utils';

const ChallengeTagsTable = ({ type }: ChallengeTagsTableProps) => {
    const { challengeTags, isFetching, fetchError } = useFetchChallengeTags(type);
    return (
        <DataCheck
            dataExists={!isEmpty(challengeTags)}
            isFetching={isFetching}
            noDataMessage="No tags found."
            error={fetchError}
        >
            <Table columns={columns} rows={challengeTags} />
        </DataCheck>
    );
};

interface ChallengeTagsTableProps {
    type: tagTypes;
}

const columns: Column<ChallengeTag>[] = [
    {
        key: 1,
        heading: 'Name',
        getValue: row => row.name,
    },
    {
        key: 2,
        heading: 'Is public?',
        getValue: row => <i className={`fas fa-${row.isPublic ? 'check' : 'times'}`} />,
    },
    {
        key: 3,
        heading: '',
        getValue: row => {
            const endpoint = getTagRouteEndpoint(row.type);
            return (
                <ButtonRow alignment="right">
                    <LinkButton color="yellow" icon="pencil" href={`/${endpoint}/edit/${row.id}`}>
                        Edit
                    </LinkButton>
                    <LinkButton color="red" icon="trash" href={`/${endpoint}/delete/${row.id}`}>
                        Delete
                    </LinkButton>
                </ButtonRow>
            );
        },
    },
];

export default ChallengeTagsTable;
